import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import colors from 'constants/colors';
import { KeycardPrintingIcon } from "assets/icons";
import { Container } from './styles';

const ModalKeycardPrinting = ({hidden, buttonStyle}) => {

  const handleFinishPrint = () => {

  }
  
  return (
    <MainModal
      className="modal-success"
      buttonStyle={buttonStyle}
      hidden={hidden}
      additionalStyle={`
        max-width: 398px;
        .modal-content{
          height: 274px;
          .close {
            z-index: 200;
          }   
          .modal-body{
            position: relative;
            top: -15px;
            height: 100%;
          }
        }
        background: ${colors.grey3};
        top: 179px;
      `}
    >
      <Container>
        <KeycardPrintingIcon />
        <div>Your key is being printed at Kiosk 2.</div>
        <Button
          success
          additionalStyle={`
            height: 53px;
            width: 130px;
          `}
          onClick={handleFinishPrint}
        >
          Finish
        </Button>
      </Container>
    </MainModal>
  );
}

export default ModalKeycardPrinting;